import * as DateFNS from "date-fns"

const isTextValid = (text) => {
    return (text !== null && text !== undefined && text.length > 0);
}

const isEmailValid = (text) => {
    /* eslint-disable no-control-regex */
    const regex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i
    return text.match(regex) !== null;
}

const isPhoneNumberValid = (text) => {
    const regex = /^[+]?[0-9]{6,12}$/;
    return text.match(regex) !== null;
}

const isFiscalCodeValid = (fiscalCode) => {
    let retVal = false;

    if (fiscalCode && fiscalCode.length === 16) {
        const re = /^[0-9]{11}|[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/g;
        const matches = fiscalCode.toUpperCase().match(re);
        if (matches) {
            retVal = true;
        }
    }

    return retVal;
}

const ageFromFiscalCode = (fiscalCode) => {
    const re = /([A-Z]{3})([A-Z]{3})(\d{2})([A-Z])(\d{2})([A-Z])(\d{3})([A-Z])/;
    const matches = fiscalCode?.toUpperCase().match(re);
    let age = null;
    if (matches) {

        const annoCorrente = parseInt(DateFNS.format(new Date(), "yy"));

        const anno = parseInt(matches[3]);
        const meseStr = matches[4];
        const giorno = matches[5];

        const mesi = ['A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T'];
        const mese = mesi.indexOf(meseStr.toUpperCase()) + 1;

        const annoCF = annoCorrente < anno ? (anno + 1900) : (anno + 2000);

        const giornoCF = giorno > 40 ? (giorno-40) : giorno;

        const dateStr = `${annoCF}-${mese}-${giornoCF}`;
        let dt = DateFNS.parse(dateStr, 'yyyy-M-d', new Date());

        age = DateFNS.differenceInYears(new Date(), dt);
    }
    return age;    
}

const isMinorFiscalCode = (fiscalCode) => {
    const age = ageFromFiscalCode(fiscalCode);
    return age && age < 18;
}

const hasLessThen12Years = (fiscalCode) => {
    const age = ageFromFiscalCode(fiscalCode);
    return age && age < 12;
}

const validateMandatory = (text, errorText = "Il campo è obbligatorio") => {
    return !isTextValid(text) ? errorText : null;
}

const validateEmail = (text, errorText = "Email inserita non valida") => {
    return !isEmailValid(text) ? errorText : null;
}

const validatePhoneNumber = (text, errorText = "Il numero di telefono inserito non è valido") => {
    return !isPhoneNumberValid(text) ? errorText : null;
}

const validateFiscalCode = (text) => {
    let retVal = null;

    if (text && text.length === 16) {
        if (!isFiscalCodeValid(text)) {
            retVal = "Inserire un codice fiscale valido";
        }
    }
    else if (!text || text.length < 16) {
        retVal = "E' necessario inserire il codice fiscale completo";
    }

    return retVal;
}

const validateMinorFiscalCode = (text, errorText = "Hai inserito il codice fiscale di un minorenne") => {
    return isMinorFiscalCode(text) ? errorText : null;
}

const validateAgeLessThen12Years = (text, errorText = "E' necessario avere almeno 12 anni per effettuare il preordine") => {
    return hasLessThen12Years(text) ? errorText : null;
}

const isProjectStatusUnavailable = (project) => {
    return (project.status === 'soldout') || (project.status === 'close');
}

export { isTextValid, isEmailValid, isPhoneNumberValid, isFiscalCodeValid, validateMandatory, validateEmail, validatePhoneNumber, validateFiscalCode, isMinorFiscalCode, validateMinorFiscalCode, validateAgeLessThen12Years, hasLessThen12Years, isProjectStatusUnavailable };
